import React, { FC } from 'react';
import { CtaCardFragment } from '../../../../types/graphqlTypes';
import { CTACard } from '../../../CtaCard';

export const CtaCard: FC<CtaCardFragment> = (props) => (
  <CTACard {...props} shadow inlineButton tightSpacing headingComponent="h2" />
);

// Note: Fragment for this is in main component renderer
// src/components/componentRenderer/components/CTACard.tsx
